import { Coach } from '../types';
import { AppState } from '../../rootReducer';
import { CoachState } from '../types';

export const getState = (state: AppState): CoachState => state.coachReducer;

export const getCoachList = (state: AppState): Coach[] => state.coachReducer.coach || [];

export const getLoggedCoach = (state: AppState): Coach | undefined | null => {
    if (!state.coachReducer.coach.length) return null;
    return state.coachReducer.coach.find((coach) => coach.uid === state.authReducer.currentUser?.uid);
};

export const isLoading = (state: AppState): boolean => state.coachReducer.isLoading;

export const getError = (state: AppState): string => state.coachReducer.error || '';
